// Site animations (merchant, 19 Oct 2026). Everything is skipped for shoppers who ask their phone for reduced motion.
// 1) Headings and card rows below the fold glide up into view as you scroll (cards one after another).
// 2) Reviews summary: 4.9 counts up and the stars fill in.
// 3) Add to Cart buttons briefly show "Added ✓" after a tap.
// 4) Product page: WhatsApp button pulses gently; the mobile sticky Add to Cart bar slides up (CSS).
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const addedLabel = document.documentElement.dataset.addedLabel || 'Added ✓';

function reveal() {
  const main = document.getElementById('main-content');
  if (!main || !('IntersectionObserver' in window)) return;
  const fold = window.innerHeight;
  const targets = [
    ...main.querySelectorAll('ul[role="list"]'),
    ...document.querySelectorAll('.hbr-dir'),
  ].filter((el) => {
    if (el.closest('.hbr-hero-wrap, header, [data-sticky-atc], details:not([open]) ul, dialog, .hbr-promise')) return false;
    if (el.matches('ul') && el.children.length < 2) return false;
    return el.getBoundingClientRect().top > fold * 0.9;
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  targets.forEach((el) => {
    el.classList.add(el.matches('ul') ? 'hbr-in-list' : 'hbr-in');
    io.observe(el);
  });
}

function reviewsCount() {
  const score = document.querySelector('.hbr-rv-summary__score');
  if (!score) return;
  const box = score.closest('.hbr-rv-summary');
  const final = parseFloat(score.textContent) || 0;
  box.classList.add('hbr-stars-anim');
  const io = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting) return;
    io.disconnect();
    box.classList.add('is-in');
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / 1200);
      score.textContent = (final * (1 - Math.pow(1 - p, 3))).toFixed(1);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, { threshold: 0.4 });
  io.observe(box);
}

function addedFeedback() {
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const btn = form.querySelector('.hbr-card-atc, .hbr-reel-buy__btn--atc');
    if (!btn || btn.dataset.added) return;
    const original = btn.innerHTML;
    btn.dataset.added = '1';
    btn.classList.add('is-added');
    btn.textContent = addedLabel;
    setTimeout(() => {
      btn.innerHTML = original;
      btn.classList.remove('is-added');
      delete btn.dataset.added;
    }, 1800);
  }, true);
}

addedFeedback();
if (!reduce) {
  document.documentElement.classList.add('hbr-anim');
  const start = () => { reveal(); reviewsCount(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}
